import { AuthRouter } from 'auth/AuthRouter';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'portal/Context';
import React from 'react';

const AuthApp = () => {
  return (
    <BrowserRouter>
      <Provider
        phone={window.AppConfigState.phone.main}
        tel={window.AppConfigState.phone.main_tel}
      >
        <div className='authApp'>
          <div className='authRouter'>
            <AuthRouter />
          </div>
        </div>
      </Provider>
    </BrowserRouter>
  );
};

export default AuthApp;
